"use client";
import React, { useState } from "react";
import Image from "next/image";

export default function MembersCard({ member }) {
  const { id, name, role, image, summary, alt } = member;

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <article
      key={id}
      className="bg-white shadow-md flex flex-col min-h-60 col-span-2 md:odd:last:col-start-2"
    >
      <div className="p-2 sm:p-10 flex flex-col gap-y-4 flex-grow">
        <div className="flex flex-row items-center gap-4">
          <div>
            <Image
              src={image}
              alt={alt || "Member image"}
              width={100}
              height={100}
              className="w-16 h-16 border border-tertiary-accent shadow-md rounded-full mx-auto"
            />
          </div>
          <div className="flex flex-col max-w-32 min-[330px]:max-w-none">
            <p className="font-bold text-textPrimary">{name}</p>
            <p className="text-textPrimary whitespace-normal break-words max-[250px]:text-xs max-[360px]:text-sm">
              {role}
            </p>
          </div>
        </div>

        <div className="flex flex-col px-1 md:px-0 flex-grow">
          <p
            className={`text-textPrimary mt-2 transition-all duration-300 ${
              isExpanded ? "" : "line-clamp-4"
            }`}
          >
            {summary}
          </p>
        </div>

        <button
          className="mt-auto text-tertiary-accent underline flex justify-end pr-2 md:pr-0"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Show less" : "Read more..."}
        </button>
      </div>
    </article>
  );
}
